import { getUser } from "@/utils/user"
import { getUrlByPath } from "@/utils/uploadFile"

export default {
  methods: {
    getDetailInfo(history) {
      let result = []
      history.forEach((item, index) => {
        if (index === 0) {
          let trigger = {}
          trigger.state = "发起审批"
          trigger.user = getUser(item.userId)
          trigger.createAt = item.createAt
          result.push(trigger)
        }
        let verifyResult = {}
        verifyResult.state = this._.keys(item).includes("pass")
          ? item.pass === true
            ? "已通过"
            : "已驳回"
          : "审批中"
        if (item.status == "RECALLED") verifyResult.state = "已撤回"
        let adviceUserIds = this._.keys(item.resultMap)
        verifyResult.adviceList = adviceUserIds.map(userId => {
          return Object.assign({}, item.resultMap[userId], {
            user: getUser(userId),
            sign: getUrlByPath(item.resultMap[userId]?.signAttachment?.path)
          })
        })
        verifyResult.createAt = item.finishAt
        if (item.or) {
          if (["审批中", "已撤回"].includes(verifyResult.state)) {
            verifyResult.name = "审批成员或签"
            verifyResult.approval = item.candidateUserIds?.map(userId => ({
              user: getUser(userId),
              pass: null
            }))
          } else {
            verifyResult.user = getUser(item.verifyUserId)
          }
        } else {
          verifyResult.name = "审批成员会签"
          verifyResult.approval = item.candidateUserIds?.map(userId => {
            let approvalItem = {}
            approvalItem.user = getUser(userId)
            approvalItem.pass = item.finishedUserIds?.includes(userId)
              ? true
              : item.verifyUserId === userId
              ? false
              : null
            return approvalItem
          })
        }
        result.push(verifyResult)
      })
      let lastItem = this._.last(history)
      if (this._.keys(lastItem).includes("pass") || lastItem.status == "RECALLED")
        result.push({ state: "结束", createAt: history[history.length - 1].finishAt })
      return result
    }
  }
}
